if (!customElements.get('tooltip-interactive')) {
    customElements.define(
        'tooltip-interactive',
        class TooltipInteractive extends HTMLElement {

            constructor() {
                super();
            }

            connectedCallback() {
                this.tooltipButton = this.querySelector('.tooltip--interactive__button');
                this.tooltip = this.querySelector('.tooltip--interactive');
                this.focusableChildren = this.tooltip.querySelectorAll(
                    'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
                );

                this.setChildrenFocusable(false);

                this.mapEvents();
            }

            disconnectedCallback() {
                this.tooltipButton.removeEventListener('keyup', this.handleButtonKeyup.bind(this));
                this.tooltipButton.removeEventListener('click', this.showTooltip.bind(this));
                this.removeEventListener('focusout', this.handleFocusOut.bind(this));
            }

            mapEvents() {
                this.tooltipButton.addEventListener('keyup', this.handleButtonKeyup.bind(this));
                this.tooltipButton.addEventListener('click', this.showTooltip.bind(this));
                this.addEventListener('focusout', this.handleFocusOut.bind(this));
            }

            handleButtonKeyup(ev) {
                ev.stopPropagation();

                if (ev.key === 'Escape') {
                    this.hideTooltip()
                }
            }

            handleFocusOut(event) {
                const newTarget = event.relatedTarget;
                if (newTarget && this.contains(newTarget)) {
                    return;
                }

                this.hideTooltip();
            }

            showTooltip() {
                this.tooltipButton.setAttribute('aria-expanded', 'true');
                this.tooltip.classList.add('tooltip--visible');
                this.setChildrenFocusable(true);
            }

            hideTooltip() {
                this.tooltipButton.setAttribute('aria-expanded', 'false');
                this.tooltip.classList.remove('tooltip--visible');
                this.setChildrenFocusable(false);
            }

            setChildrenFocusable(isFocusable) {
                this.focusableChildren.forEach(el => {
                    if (isFocusable) {
                        el.removeAttribute('tabindex');
                    } else {
                        el.setAttribute('tabindex', '-1');
                    }
                });
            }
        }
    );
}
